import { useSelector } from 'react-redux';
import { checkIsAdmin } from '../utils/functions';

function useIsAdmin() {
  const role = useSelector((state) => state.user.role);

  // Moderator can do everything an admin can, except for seeing the lobby
  const isAdmin = checkIsAdmin(role);

  return { isAdmin };
}

export default useIsAdmin;
